import httpService from "./http-service";

export default {
  getEnrollmentDetails() {
    return httpService.get("student/enrollment-years");
  },
  getEnrollmentYear(uuid) {
    return httpService.get(`student/enrollment-years/${uuid}`);
  },
  updateEnrollment(uuid, payload) {
    return httpService.put(`student/enrollment-years/${uuid}`, payload);
  },
};
